<template>
  <section class="maintenance-tips-section">
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <i :class="headerData.icon"></i>
          <span>{{ headerData.tag }}</span>
        </div>
        <h2>{{ headerData.title }}</h2>
        <p class="section-description">{{ headerData.description }}</p>
      </div>
      
      <div class="tips-slider swiper" ref="tipsSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide h-auto" v-for="(tip, index) in tipsData" :key="index">
            <div class="tip-card h-100">
              <div class="tip-image">
                <img :src="tip.image" :alt="tip.title" />
                <div class="tip-number">{{ index + 1 }}</div>
              </div>
              <div class="tip-content">
                <h3>{{ tip.title }}</h3>
                <p>{{ tip.description }}</p>
                <div class="tip-tags">
                  <span v-for="(tag, tagIndex) in tip.tags" :key="tagIndex" class="tip-tag">{{ tag }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue'

export default {
  name: "ServiceItsSliderRegularComp",
  props: {
    headerData: {
      type: Object,
      required: true,
      default: () => ({
        icon: "fas fa-tools",
        tag: "MAINTENANCE TIPS",
        title: "Keep Your Bike in Top Condition",
        description: "Expert tips and tricks for maintaining your bicycle"
      })
    },
    tipsData: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  setup() {
    const tipsSwiper = ref(null)

    const initTipsSwiper = () => {
      setTimeout(() => {
        const checkSwiper = () => {
          if (window.Swiper) {
            tipsSwiper.value = new window.Swiper('.tips-slider', {
              loop: true,
              autoplay: {
                delay: 4000,
                disableOnInteraction: false,
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              breakpoints: {
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                }
              }
            });
          } else {
            setTimeout(checkSwiper, 100);
          }
        };
        checkSwiper();
      }, 500);
    }

    onMounted(() => {
      initTipsSwiper()
    })

    return {
      tipsSwiper
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Maintenance Tips Section */
.maintenance-tips-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #0a0f1c 0%, #1a2332 50%, #0a0f1c 100%);
  color: #fff;
  position: relative;
  overflow: hidden;
}

.maintenance-tips-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, 
    rgba(0, 255, 150, 0.05) 0%, 
    rgba(0, 255, 200, 0.03) 25%, 
    rgba(0, 255, 100, 0.05) 50%, 
    rgba(0, 255, 150, 0.03) 75%, 
    rgba(0, 255, 200, 0.05) 100%);
  pointer-events: none;
}

.section-header {
  text-align: center;
  margin-bottom: 80px;
  position: relative;
  z-index: 2;
}

.section-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 255, 150, 0.1);
  border: 1px solid rgba(0, 255, 150, 0.3);
  padding: 8px 16px;
  border-radius: 25px;
  margin-bottom: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #00ff96;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 15px 0;
  font-family: 'Archivo', sans-serif;
}

.section-description {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 30px 0;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.tips-slider {
  width: 100%;
  padding: 0 20px 60px;
  position: relative;
  z-index: 2;
}

.tip-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(0, 255, 150, 0.2);
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
}

.tip-card:hover {
  transform: translateY(-5px);
  border-color: rgba(0, 255, 150, 0.4);
  box-shadow: 0 15px 40px rgba(0, 255, 150, 0.1);
}

.tip-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.tip-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.tip-card:hover .tip-image img {
  transform: scale(1.05);
}

.tip-number {
  position: absolute;
  top: 15px;
  right: 15px;
  background: linear-gradient(135deg, #00ff96 0%, #00ff64 100%);
  color: #000;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Archivo', sans-serif;
  box-shadow: 0 4px 15px rgba(0, 255, 150, 0.3);
}

.tip-content {
  padding: 25px;
}

.tip-content h3 {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 15px 0;
  line-height: 1.3;
  font-family: 'Archivo', sans-serif;
}

.tip-content p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.tip-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tip-tag {
  background: rgba(0, 255, 150, 0.1);
  color: #00ff96;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid rgba(0, 255, 150, 0.2);
}

/* Swiper Pagination */
.swiper-pagination {
  position: relative;
  margin-top: 40px;
}

.swiper-pagination-bullet {
  background: rgba(0, 255, 150, 0.3);
  opacity: 1;
  width: 12px;
  height: 12px;
  margin: 0 6px;
}

.swiper-pagination-bullet-active {
  background: #00ff96;
}

/* Responsive Design */
@media (max-width: 991px) {
  .section-header h2 {
    font-size: 36px;
  }
  
  .section-description {
    font-size: 16px;
  }
  
  .tips-slider {
    padding: 0 10px 60px;
  }
}

@media (max-width: 767px) {
  .section-header h2 {
    font-size: 28px;
  }
  
  .section-description {
    font-size: 14px;
  }
  
  .tip-content {
    padding: 20px;
  }
  
  .tip-content h3 {
    font-size: 18px;
  }
  
  .tip-content p {
    font-size: 14px;
  }
  
  .tip-image {
    height: 180px;
  }
}
</style>
